import React from "react";
import { useRef, MouseEvent } from 'react';
import { ListGroup } from "react-bootstrap"
import { ISelectableListItemProps } from "../../interfaces/Components/SelectableList/ISelectableListItemProps"

export const SelectableListItem = ({uniqueName, item, onChange} : ISelectableListItemProps) => {

    const buttonRef = useRef<HTMLButtonElement>(null);

    const checkChildCheckbox = () => {
        onChange(item.Key, !item.Checked);
    };

    const switchFocusToButtonOnCheckboxClick = (event: MouseEvent<HTMLInputElement>) => {
        buttonRef?.current?.focus();
        event.preventDefault();
        return false;
    };

    const switchFocusToButtonOnLabelClick = (event: MouseEvent<HTMLLabelElement>) => {
        buttonRef?.current?.focus();
        event.preventDefault();
        return false;
    };

    return  <ListGroup.Item id={`${uniqueName}-button-${item.Key}`} action onClick={checkChildCheckbox} as="button" ref={buttonRef}>
                <div className="form-check">
                    <input tabIndex={-1}
                           onClick={switchFocusToButtonOnCheckboxClick}
                           type="checkbox"
                           readOnly
                           id={`${uniqueName}-selectable-list-item-${item.Key}`}
                           className="form-check-input" checked={item.Checked}
                    />

                    <label onClick={switchFocusToButtonOnLabelClick}
                           htmlFor={`${uniqueName}-selectable-list-item-${item.Key}`}
                           className="form-check-label">
                        {item.Label}
                    </label>
                </div>
            </ListGroup.Item>
};